import { get } from 'lodash';
import { states } from '@/constants/lifecycle';
import hasDatasourceChanged from '../datasource/helper';
import { datasetIsDirty, datasetStepsIncludes } from '../state/state';
import { datasetSettingsStep } from '../constants';

export const disableDatasetEdit = ({ attachments, uploadStatus }) => (uploadStatus === states.PENDING
  || get(attachments, 'uploadStatus', states.NONE) === states.PENDING);

export const disableDatasetOnUpload = ({
  uploadStatus,
  attachments,
  isDirty,
  readStatus,
}) => disableDatasetEdit({ attachments, uploadStatus })
|| !!datasetIsDirty({ isDirty }) || readStatus === states.PENDING;

export const datasetCohortStatus = ({ cohorts }, {
  status,
  isEditing,
  uploadStatus,
  attachments,
  isDirty,
  readStatus,
}, hasDictionary) => ({
  cohortAllowed: cohorts.create,
  cohortDisabled: disableDatasetOnUpload({
    attachments,
    isDirty,
    readStatus,
    uploadStatus,
  }) || isEditing || !hasDictionary,
  cohortSupported: status.query_enabled.supported,
  cohortUnsupportedReasons: status.query_enabled.reasons,
});

export const datasetRequestStatus = ({ requests }, {
  status,
  isEditing,
  uploadStatus,
  attachments,
  isDirty,
  readStatus,
}) => ({
  accessRequestAllowed: requests.create,
  accessRequestDisabled: disableDatasetOnUpload({
    attachments,
    isDirty,
    readStatus,
    uploadStatus,
  }) || isEditing,
  accessRequestSupported: status.request_enabled.supported,
  accessRequestUnsupportedReasons: status.request_enabled.reasons,
});

export const datasetConditionsStatus = ({ status }) => ({
  hasConditions: status?.conditional_access?.supported,
});

const datasetStatus = ({ permissions }, dataset, hasDictionary) => ({
  ...datasetCohortStatus(permissions, dataset, hasDictionary),
  ...datasetRequestStatus(permissions, dataset),
  ...datasetConditionsStatus(dataset),
});

export const disableDatasetWizardCancel = (dataset, template) => (
  template.readStatus === states.PENDING
  || dataset.saveStatus === states.PENDING
  || disableDatasetEdit(dataset)
);

export const disableDatasetToggleView = (dataset, template) => (
  template.readStatus !== states.SUCCESS
  || disableDatasetWizardCancel(dataset, template)
  || (dataset.steps.templateCode && dataset.settings.catalogue_definition_code !== dataset.steps.templateCode)
);

export const disableDatasetWizardView = (dataset, template, datasource) => (
  disableDatasetToggleView(dataset, template)
  || hasDatasourceChanged(datasource, datasource.copy)
  || datasetStepsIncludes(datasetSettingsStep, dataset.steps.activeStepIndex)
);

export default datasetStatus;
